"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNurseShiftDto = instanceOfFacilityNurseShiftDto;
exports.FacilityNurseShiftDtoFromJSON = FacilityNurseShiftDtoFromJSON;
exports.FacilityNurseShiftDtoFromJSONTyped = FacilityNurseShiftDtoFromJSONTyped;
exports.FacilityNurseShiftDtoToJSON = FacilityNurseShiftDtoToJSON;
exports.FacilityNurseShiftDtoToJSONTyped = FacilityNurseShiftDtoToJSONTyped;
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
const ShiftType_1 = require("./ShiftType");
const ShiftStatus_1 = require("./ShiftStatus");
/**
 * Check if a given object implements the FacilityNurseShiftDto interface.
 */
function instanceOfFacilityNurseShiftDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function FacilityNurseShiftDtoFromJSON(json) {
    return FacilityNurseShiftDtoFromJSONTyped(json, false);
}
function FacilityNurseShiftDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'shiftType': (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'status': (0, ShiftStatus_1.ShiftStatusFromJSON)(json['status']),
        'requestStatus': json['requestStatus'] == null ? undefined : (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['requestStatus']),
    };
}
function FacilityNurseShiftDtoToJSON(json) {
    return FacilityNurseShiftDtoToJSONTyped(json, false);
}
function FacilityNurseShiftDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'status': (0, ShiftStatus_1.ShiftStatusToJSON)(value['status']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['requestStatus']),
    };
}
//# sourceMappingURL=FacilityNurseShiftDto.js.map